const normalizePhone = phone => {
    const digits = String(phone || '').replace(/\D/g, '');
    if(!digits) return '';
    if(digits.startsWith('972')) return digits;
    if(digits.startsWith('0')) return '972' + digits.slice(1);
    return digits;
};

export const openWhatsApp = (phone, text = '') => {
    const urlWhatApp = 'https://api.whatsapp.com/send?phone=' + normalizePhone(phone) + '&text=' + encodeURIComponent(text);
    window.open(urlWhatApp);
};
